import { render, staticRenderFns } from "./NeedValidateHistoryPhysicians.vue?vue&type=template&id=65d7c77a&scoped=true&"
import script from "./NeedValidateHistoryPhysicians.vue?vue&type=script&lang=js&"
export * from "./NeedValidateHistoryPhysicians.vue?vue&type=script&lang=js&"
import style0 from "./NeedValidateHistoryPhysicians.vue?vue&type=style&index=0&id=65d7c77a&lang=scss&scoped=true&"
import style1 from "./NeedValidateHistoryPhysicians.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7c77a",
  null
  
)

export default component.exports